// src/utils/csvExport.js
// Export trades to CSV — includes all fields

export function exportTradesToCSV(trades, settings, filename = 'odftrades-export.csv') {
  if (!trades || trades.length === 0) return;

  const startBal = settings?.startingBalance || 10000;

  const headers = [
    'Date',
    'Pair / Instrument',
    'Session',
    'Direction',
    'Entry Price',
    'Stop Loss',
    'Take Profit',
    'Risk Amount ($)',
    'Risk %',
    'Lot Size',
    'Contracts',
    'Result',
    'P&L ($)',
    'P&L (%)',
    'RR Achieved',
    'Profit Factor',
    'Followed Rules',
    'Strategy / POI',
    'Order Flow',
    'Analysis TF',
    'Mistake',
    'Emotion Before',
    'Emotion After',
    'Notes',
    'Screenshot Link',
  ];

  const rows = trades.map(t => {
    const pnlPct = startBal > 0 ? ((Number(t.pnl || 0) / startBal) * 100).toFixed(2) : '0.00';
    const riskPct = startBal > 0 ? ((Number(t.riskAmount || 0) / startBal) * 100).toFixed(2) : '0.00';

    return [
      t.date || '',
      t.pair || '',
      t.session || '',
      t.direction || '',
      t.entryPrice || '',
      t.stopLoss || '',
      t.takeProfit || '',
      t.riskAmount || '',
      riskPct,
      t.lotSize || '',
      t.contracts || '',
      t.result || '',
      Number(t.pnl || 0).toFixed(2),
      pnlPct,
      t.rrAchieved || '',
      '',
      t.followedRules === true || t.followedRules === 'true' ? 'Yes' : 'No',
      t.poi || '',
      t.orderFlow || '',
      t.analysisTF || '',
      t.mistakeMade || '',
      t.emotionBefore || '',
      t.emotionAfter || '',
      (t.notes || '').replace(/,/g, ';').replace(/\n/g, ' '),
      t.screenshotLink || '',
    ];
  });

  // Build CSV string
  const csvContent = [
    headers.join(','),
    ...rows.map(row =>
      row.map(cell => {
        const str = String(cell);
        // Quote cells that contain commas, quotes, or newlines
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
          return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      }).join(',')
    )
  ].join('\n');

  // Download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href  = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function getCSVTemplate() {
  // Returns a blank CSV template users can fill in for import
  const headers = [
    'date', 'pair', 'session', 'direction', 'entry_price',
    'stop_loss', 'take_profit', 'risk_amount', 'lot_size',
    'contracts', 'result', 'pnl', 'rr_achieved',
    'followed_rules', 'poi', 'order_flow', 'analysis_tf',
    'mistake_made', 'emotion_before', 'emotion_after',
    'notes', 'screenshot_link'
  ];
  const example = [
    '2026-01-15', 'XAU/USD', 'London', 'Buy', '2315.00',
    '2310.00', '2325.00', '100', '0.10',
    '', 'Win', '50.00', '2.5',
    'Yes', 'Order Block', 'Trend', '1H',
    'None', 'Calm', 'Calm',
    'Clean setup on 1H OB', ''
  ];
  const csv = [headers.join(','), example.join(',')].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href  = url;
  link.download = 'odftrades-import-template.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
